// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1134Q","additionalInfo":"AgreementModal_additionalInfo__3BHLJ"};